import { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faPlus, faChevronCircleLeft, faEye, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useToast } from '../components/common/ToastProvider';
import {
  PageContainer,
  SectionTitle,
  ButtonSuccess,
  FormGroup,

  FormRow,
  Label,
  Divider,
  CardTitle,
  fadeIn,
  useGoBack,
  Textarea,
  Button,
  InputLabelDesc
} from '../styles/PageStyles';
import { fetchTaskDetails, makeReserveTasks, saveTask, submitTask } from '../services/TaskService';
import { FaLock } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import EmptyState from '../components/common/EmptyState';


const Container = styled.div`
  // background-color: #f9fafb; 
  // padding: 1.5rem;
`;

const MaxWidthWrapper = styled.div`
`;

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.9rem 1rem;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 255, 0.15);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.9rem;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
  
  &::placeholder {
    color: var(--text-secondary);
  }
`;

const TableRow = styled.tr`
  height: ${props => props.height || '35px'};
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }
`;

const TableCell = styled.td`
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  color: #374151;

  &.label {
    width: 200px;
    font-weight: 600;
    color: #1f2937;
  }

  &.separator {
    width: 30px;
    padding: 0.5rem 0.5rem;
    text-align: center;
    color: #9ca3af;
  }

  &.value {
    color: #111827;
  }

  &.icon {
    width: 30px;
    padding: 0.5rem;
    text-align: center;
  }
`;

const SectionHeader = styled.button`
  width: 100%;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f4f6;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #eff6ff;
  }

  h2, h3 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #111827;
  }
`;

const SectionHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const SectionHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Badge = styled.span`
  font-size: 0.75rem;
  background-color: #dbeafe;
  color: #1e40af;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-weight: 600;
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: ${props => props.status === 'reserved' ? '#dbeafe' : '#fef3c7'};
  color: ${props => props.status === 'reserved' ? '#1e40af' : '#92400e'};
`;

const EditableInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  font-size: 0.875rem;
  border: 1px solid #93c5fd;
  border-radius: 0.375rem;
  outline: none;

  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const ActionsContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`;

// const Button = styled.button`
//   padding: 0.5rem 1.5rem;
//   font-weight: 500;
//   border-radius: 0.5rem;
//   border: none;
//   cursor: pointer;
//   transition: all 0.2s ease;

//   &.cancel {
//     background-color: white;
//     color: #374151;
//     border: 1px solid #d1d5db;

//     &:hover {
//       background-color: #f9fafb;
//     }
//   }

//   &.save {
//     background-color: #2563eb;
//     color: white;

//     &:hover {
//       background-color: #1d4ed8;
//     }
//   }

//   &.readonly {
//     background-color: #f3f4f6;
//     color: #9ca3af;
//     cursor: not-allowed;
//   }
// `;

const SectionContent = styled.div`
  display: ${props => props.isExpanded ? 'block' : 'none'};
`;

// Custom green toggle switch component
const GreenSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
  
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  
  input:checked + .slider {
    background-color: #76b947;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #76b947;
  }
  
  input:checked + .slider:before {
    transform: translateX(30px);
  }
`;

const Modal = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

const ModalContent = styled(motion.div)`
  width: 900px;
  max-width: 90%;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 16px;
  padding: 2rem;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 102, 255, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 102, 255, 0.2);
    border-radius: 4px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

const ModalTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-primary);
  background: var(--gradient-primary);
  // font-family: 'Manrope', sans-serif;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-secondary);
  
  &:hover {
    color: var(--text-primary);
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 102, 255, 0.1);
`;

const MultiFieldDataButton = styled.div`
    border: 1px solid rgba(0, 102, 255, 0.15);
    width: 100%;
    height: 50px;
    display: block;
    border-radius: 8px;
    position: relative;
  }
`

const ShowMoreFieldButton = styled.button`
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    padding: 5px 20px;
    background: #66a3ff;
    border: 1px solid#fff;
    color: #fff;
}
`

// utils
const isObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const FieldRenderer = ({ data, onChange, parentKey = "", disabled}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visibleModals, setVisibleModals] = useState({});


  return (
    <FormRow style={{ gridTemplateColumns: `repeat(3, 1fr)` }}>
      {Object.keys(data || {}).filter(element => element !== "id").map((key) => {
        const value = data[key];
        const compositeKey = parentKey ? `${parentKey}.${key}` : key;
        const openModal = () =>
          setVisibleModals(prev => ({ ...prev, [compositeKey]: true }));

        const closeModal = () =>
          setVisibleModals(prev => ({ ...prev, [compositeKey]: false }));

        const handleChange = (newVal) => onChange(compositeKey, newVal);

        return (
          
            <FormGroup>
              <Label>
                {key.replaceAll("_", " ")}
              </Label>
           

            {/* SIMPLE VALUE */}
            {!isObject(value) && (
              <Input
                type="text"
                disabled={disabled}
                value={value ?? ""}
                onChange={(e) => handleChange(e.target.value)}
              />
            )}
            

            {isObject(value) && <MultiFieldDataButton>
              <span
                style={{
                 position:'absolute',
                 top:'0.6rem',
                 paddingLeft:'14px'
                }}
              >{`${Object.keys(value).length} fields present`}</span>
              <ShowMoreFieldButton onClick={openModal}>View</ShowMoreFieldButton>
              </MultiFieldDataButton>}
            {/* NESTED OBJECT */}
            {isObject(value) && visibleModals[compositeKey] && (

              <Modal
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setIsModalVisible(false)}
              >
                <div onClick={e => e.stopPropagation()}>
                  <ModalContent
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                  >
                    <ModalHeader>
                      <ModalTitle>{key}</ModalTitle>
                      <CloseButton onClick={closeModal}>×</CloseButton>
                    </ModalHeader>
                    {console.log(value)}
                    <FieldRenderer
                      data={value}
                      disabled={disabled}
                      parentKey={compositeKey}
                      onChange={onChange}
                    />

                    {/* Modal Footer */}
                    <ModalFooter>

                      {!disabled && (
                        <Button primary onClick={closeModal}>
                          Save
                        </Button>
                      )}
                    </ModalFooter>
                  </ModalContent>
                </div>
              </Modal>
            )}
             </FormGroup>
          
        );
      })}
    </FormRow>
  );
};



const TaskDetails = () => {
  const { id } = useParams();
  const [taskData, setTaskData] = useState(null);
  const {showToast} = useToast();
  const navigate = useNavigate();
  const { user } = useAuth();

  const fetchTaskDetail = async () => {
      const payload = {
        filter: {
          response: {
            "task_id": id
          }
        }
      }
      const resp = await fetchTaskDetails(payload)
      const data = resp[0];
      console.log(data)
      setTaskData(data);
    }


  useEffect(() => { 
    console.log("useEfct called")
    fetchTaskDetail();

  }, [id])

  useEffect(() => {
    console.log("This is the useEffect")
    console.warn("This is the useEffect warning")
  }, [])

  const goBack = useGoBack();

  if (!taskData) {
    return;
  }

  const handleReserveTask = async (id) => {
    const payload = { task_id: id };

    try {
      const { status, reserved_tasks, already_reserved_tasks } = await makeReserveTasks(payload);

      if (status !== "SUCCESS") {
        showToast({
          message: "Failed to reserve task. Please try again.",
          type: "error"
        });
        return;
      }

      if (reserved_tasks && reserved_tasks.length > 0) {
        showToast({
          message: "Task reserved successfully.",
          type: "success",
          duration: 4000
        });
      }

      if (already_reserved_tasks && already_reserved_tasks.length > 0) {
        const reservedIds = already_reserved_tasks.map(task => task.task_id).join(', ');

        showToast({
          message: `Note: Tasks ${reservedIds} were already reserved.`,
          type: "warning",
          duration: 6000
        });
        console.warn(`Attempted to reserve already reserved tasks: ${reservedIds}`);
      }

      fetchTaskDetail();

    } catch (error) {
      console.error("Error during task reservation:", error);
      showToast({
        message: "An unexpected error occurred during reservation.",
        type: "error"
      });
    }
  };

  const handleSaveTask = async () => {
    try {
      const payload = {
        "pipeline_id": null,
        "document_urls": [],
        "payload": {
          "pipeline_execution_id": taskData?.pipeline_id,
          "task_data": taskData?.response?.task_data
        }
      }
      
      const resp = await saveTask(payload);
      if(resp.status == "SUCCESS") {
        showToast({
          message: "Task has been saved Successfully.",
          type:"success",
          duration:4000
        })
      }
    } catch (error) {
      console.log("Something went wrong while saving the task",error)
    }  
  }

   const handleSubmitTask = async () => {
    try {
      const payload = {
        "pipeline_id": null,
        "document_urls": [],
        "payload": {
          "pipeline_execution_id": taskData?.pipeline_id,
          "task_data": taskData?.response?.task_data
        }
      }
      
      const resp = await submitTask(payload);
      if(resp.status == "SUCCESS") {
        showToast({
          message: "Task has been submitted Successfully.",
          type:"success",
          duration:4000
        })
        navigate(`/inbox`);
      }
    } catch (error) {
      console.log("Something went wrong while saving the task",error)
    }  
  }

const updateNestedValue = (obj, path, value) => {
  const keys = path.split(".");
  const lastKey = keys.pop();

  const newObj = structuredClone(obj);

  let current = newObj;

  for (const key of keys) {
    if (typeof current[key] !== "object" || current[key] === null) {
      current[key] = {}; 
    }
    current = current[key];
  }
  current[lastKey] = value;

  return newObj;
};



  const taskName = taskData?.response?.task_name;
  const taskDesc = taskData?.response?.task_description;
  const taskStatus = taskData?.response?.task_status;
  const taskId = id;
  const entityData = taskData?.response?.task_data?.entity;
  const associated_entitiesData = taskData?.response?.task_data?.associate_entities
  const assignment_status = taskData?.response?.assignment_status;
  const reserved_user = taskData?.response?.reserved_user;
  const logedin_user = `${user?.firstname} ${user?.lastname}`;


  
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {taskData?.response?.task_name}
        </SectionTitle>
        <Divider />

        <Container>
          <MaxWidthWrapper>

            {/* Task Header Section */}
            <Card>
              <Table>
                <tbody>
                  <TableRow height="35px">
                    <TableCell className="label">Name</TableCell>
                    <TableCell className="separator">:</TableCell>
                    <TableCell className="value" style={{ fontWeight: '500' }}>
                      {taskName}
                    </TableCell>
                  </TableRow>
                  <TableRow height="35px">
                    <TableCell className="label">Description</TableCell>
                    <TableCell className="separator">:</TableCell>
                    <TableCell className="value">
                      {taskDesc}
                    </TableCell>
                  </TableRow>
                  <TableRow height="35px">
                    <TableCell className="label">Status</TableCell>
                    <TableCell className="separator">:</TableCell>
                    <TableCell className="value">
                      <StatusBadge status={taskStatus}>
                        {taskStatus?.charAt(0).toUpperCase() + taskStatus?.slice(1)}
                      </StatusBadge>
                    </TableCell>
                  </TableRow>
                  <TableRow height="35px">
                    <TableCell className="label">Task ID</TableCell>
                    <TableCell className="separator">:</TableCell>
                    <TableCell className="value" style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
                      {taskId}
                    </TableCell>
                  </TableRow>
                </tbody>
              </Table>
            </Card>

          </MaxWidthWrapper>
        </Container>

        {!!entityData &&
          <>
            <SectionTitle>Entities</SectionTitle>
            <Divider />


            <SectionTitle style={{ fontSize: '1rem', marginBottom: '30px' }}>{entityData?.name.replaceAll("_", " ")}</SectionTitle>
            <FieldRenderer
              data={entityData?.value}
              disabled={taskStatus === "CLOSED" || assignment_status === "WAITING" || reserved_user !== logedin_user}
              onChange={(fieldPath, value) => {
                setTaskData(prev => {
                  const updatedValue = updateNestedValue(
                    { ...prev.response.task_data.entity.value },
                    fieldPath,
                    value
                  );

                  return {
                    ...prev,
                    response: {
                      ...prev.response,
                      task_data: {
                        ...prev.response.task_data,
                        entity: {
                          ...prev.response.task_data.entity,
                          value: updatedValue
                        }
                      }
                    }
                  }
                });
              }}
            />
          </>

        }



        {/* </FormRow> */}

        {
          (!!associated_entitiesData && associated_entitiesData.length > 0) && <>
            <SectionTitle>Associated Entities</SectionTitle>
            <Divider />
            {
              associated_entitiesData.map((entity, index) => {
                return <>
                  <SectionTitle style={{ fontSize: '1rem', marginBottom: '30px' }}>{entity?.name.replaceAll("_", " ")}</SectionTitle>

                  <FieldRenderer
                    data={entity?.value}
                    onChange={(fieldPath, newValue) => {

                      setTaskData(prev => {

                        const updatedEntities = prev.response.task_data.associate_entities.map(ent => {
                          if (ent.name !== entity.name) return ent;

                          return {
                            ...ent,
                            value: updateNestedValue(ent.value, fieldPath, newValue)
                          };
                        });

                        return {
                          ...prev,
                          response: {
                            ...prev.response,
                            task_data: {
                              ...prev.response.task_data,
                              associate_entities: updatedEntities
                            }
                          }
                        };
                      });
                    }}
                  />
                </>
              })
            }
          </>
        }

        {associated_entitiesData.length == 0 && entityData == null && (
          <EmptyState 
              heading="No Data Found." 
              description="No entity and associated entity data found for the current task." />
        )}

        {assignment_status == "WAITING" &&
          <ButtonSuccess onClick={() => handleReserveTask(taskData.response.task_id)}>
            Reserve
          </ButtonSuccess>}


        {assignment_status == "RESERVED" && reserved_user == logedin_user &&
          taskStatus !== "CLOSED" &&
          <div style={{ display: 'flex', gap: '10px' }}>
            <Button primary onClick={() => handleSaveTask()}>
              <FontAwesomeIcon icon={faSave} />
              Save
            </Button>
            <Button primary onClick={() => handleSubmitTask()}>
              <FontAwesomeIcon icon={faSave} />
              Submit
            </Button>
          </div>}
      </motion.div>

    </PageContainer>
  );
}

export default TaskDetails;